import { render, staticRenderFns } from "./HappycallInfoTab.vue?vue&type=template&id=6c387f65"
import script from "./HappycallInfoTab.vue?vue&type=script&lang=js"
export * from "./HappycallInfoTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports